import { useState, useEffect, useCallback } from 'react';
import { notificationAPI } from '../services/api';

const POLL_INTERVAL_MS = 60000;

export function useNotificationCount() {
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setUnreadCount(0);
      return;
    }
    try {
      const res = await notificationAPI.getUnreadCount();
      const count = res.data?.data?.count ?? res.data?.count ?? 0;
      setUnreadCount(count);
    } catch {
      // ignore — user may be on a public page
    }
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [refresh]);

  return { unreadCount, refreshUnreadCount: refresh };
}

export default useNotificationCount;
